var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseEmailPart',_vm._b({staticClass:"body-image-container part-inner-container"},'BaseEmailPart',_vm.$attrs,false),[_c('img',{attrs:{"src":_vm.imageSrc,"alt":_vm.imageAlt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }